
export default {

    register: {
        personal_info: "Informations personnelles",
        commercial_info: "Informations commerciales",
        account_info: "Informations du compte",
        registration_form: "Inscription Commerçant",
        
        full_name: "Nom et prénom*",
        
        placeholders:{
            full_name: "Entrez votre nom complet",
            address: "Entrez l'adresse de votre magasin",
            business_number: "Entrez votre numéro de registre de commerce",
            gifty_password : "Entrez votre mot de passe Gifty",
             location: "Localisez votre magasin sur la carte",
        },

        phone_rate_limit_exceeded: "Trop de tentatives. Veuillez réessayer plus tard.",
        phone_number: "Numéro de téléphone*",
        wilaya: "Wilaya*",
        commune: "Commune*",
        address: "Adresse du magasin*",
        business_number: "Numéro de registre de commerce*",
        shop_location: "Localisation du magasin*",
        poster_title: "Photos des affiches Gifty*",
        shop_title: "Photos extérieures du magasin*",
        gifty_password: "Mot de passe Gifty*",
        confirm_registration: "Confirmer l'inscription",
        verify_phone_number: "Verifier Numero Téléphone",
        max_photos_upload: "Vous pouvez téléverser jusqu'à 3 photos.",
        type: "Type de magasin*",
        location: {
            modal_title: "Localisation du magasin ",
            submit: "Enregistrer la Localisation ",
            cancel: "Annuler",
            instructions: "Indiquez l’emplacement de votre magasin en cliquant sur la carte.",


        },

        phone_step_description: "Veuillez entrer votre numéro de téléphone pour commencer le processus d'inscription.",

        errors: {
            phone: "• Numéro de téléphone invalide",
            server: "• Erreur Connection Serveur",
            code: "• Code Incorrecte",
            file_required: "Aucun fichier sélectionné",
            fullname_required: "Le nom complet est obligatoire.",
            fullname_invalid: "Nom complet invalide.",
            address_required: "Adresse est obligatoire.",
            type_required: "Type du magasin ext obligatoire",
            business_number_required: "Numéro d’identification commerciale",
            geolocation_required: "Localisation du magasin",
            wilaya_required: "Wilaya",
            commune_required: "Commune",
            password_required: "Mot de passe",
            address_too_short: "L'adresse est trop courte.",
            address_too_long: "L'adresse est trop longue.",

        },
        verification: {
            verification_title: "Vérification du numéro de téléphone",
            description: "Veuillez entrer le code que vous avez reçu par SMS.",
            didnt_get_code: "Vous n'avez pas reçu le code ?",
            resend: "Renvoyer",
            resendIn: "Code envoyé, vous pourrez renvoyer dans {seconds}s",
        },
        phone_verification_success: "Numéro confirmé avec succès.",
        phone_verification_failed: "Échec de la vérification du téléphone: le code est incorrect.",

        registration_success: "Inscription réussie",
        registration_failed: "Échec de l'inscription",
        upload_failed: "Échec du téléversement, veuillez réessayer plus tard",
        success: {
            main_title: "Inscription réussie ! Bienvenue chez",
            description: "Rechargez votre solde GIFTY et payez vos factures, recharges téléphoniques, abonnements et +3M de produits e-commerce depuis une seule application",
            download: "Télécharger l'Application"
        },

        stepper: {
            phone : "Téléphone",
            verification : "Vérification",
            registration: "Inscription"
        },
        filePreview:{
            upload: "Cliquez pour téléverser des photos (max 3)"
        }

    }
}